import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

/** A settings card's title with its icon tile. */
export function SettingsCardTitle({
  icon: Icon,
  children,
}: {
  icon: LucideIcon;
  children: ReactNode;
}): React.JSX.Element {
  return (
    <div className="flex items-center gap-2">
      <span className="flex size-8 items-center justify-center rounded-xl bg-purple-100">
        <Icon className="size-4 text-purple-700" />
      </span>
      <h2 className="font-heading text-lg font-medium text-gray-900">
        {children}
      </h2>
    </div>
  );
}
